// removed by extract-text-webpack-plugin
module.exports = {"assistedLivingCard":"cx_cy"};


//////////////////
// WEBPACK FOOTER
// ./src/partials/partials.module.scss
// module id = 1699
// module chunks = 0